import {
  ICreatePublicNotification,
  IPublicNotification,
  IPublicNotificationsResponse,
} from 'views/types/publicNotifications';
import { $api } from './interceptor';

const publicNotificationsApi = () => {
  const getList = async (params: { page: number; pageSize: number }) => {
    const { data } = await $api.get<IPublicNotificationsResponse>(
      '/api/admin/public-notifications',
      { params }
    );
    return data;
  };

  const create = async (payload: ICreatePublicNotification) => {
    const { data } = await $api.post<IPublicNotification>(
      '/api/admin/public-notifications',
      payload
    );
    return data;
  };

  const cancel = async (id: string) => {
    const { data } = await $api.post<IPublicNotification>(
      `/api/admin/public-notifications/${id}/cancel`
    );
    return data;
  };

  return { getList, create, cancel };
};

export const publicNotificationsService = publicNotificationsApi();
